import type { FaireProductEntity } from "../../entity_types/product";

export const p_fr4jk43am9: FaireProductEntity = {
  token: "p_fr4jk43am9",
  type: "product",
  name: "TBF Organic Utility Canvas Tote - OR292",
  brandToken: "b_9ns7v1vn8m",
  brandName: "TBF",
  imageUrl:
    "https://cdn.faire.com/fastly/b685046952eea3558aab69fd4a677da56b938c58f5f87bce2ede03e321e3dd82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ca306a52664f2c3eb0eaa02be0886a2ce312367bbf40f835ecb3646d9b9260f.jpeg",
    "https://cdn.faire.com/fastly/bb0387f0280728ba5ac0071cadf8d9be78999b924c5c5209d99a9110afc225f0.jpeg",
    "https://cdn.faire.com/fastly/4f6aa4f3b896aa73ee93642a5281b4921242ca1b735087a542d8ebbe7b81d623.jpeg",
    "https://cdn.faire.com/fastly/450fb4e6c4e400eceb90dcb47fd40522b2bcba4b52f5ecfb7b2adb47b4be51a3.jpeg",
    "https://cdn.faire.com/fastly/7b44d9fa32e05918b88b5046fc678f955d7d6cd4e662b0cbbd8e61584c9a4d95.jpeg",
    "https://cdn.faire.com/fastly/1cc6ce17881c6487ce85aec732e1393844dd104a0411c1f20b2a2b3a6631fd76.jpeg",
    "https://cdn.faire.com/fastly/b8aa0c84cdc75c347264864576dbc6c16e5fadb2c9600bdb6c0203fd5782123c.jpeg",
    "https://cdn.faire.com/fastly/6c270a45ed22a67691e2e59b868a9e0331a069397d93f69b090425c6c2c53386.jpeg",
    "https://cdn.faire.com/fastly/f04f88fc421cb0b8961c62ef58fd236a32165085dba0373f6988291ac175e6a8.jpeg",
  ],
  priceDollars: 5.76,
  description:
    'Choose the Organic Utility Canvas Tote, a perfect blend of versatility and eco-friendliness for your daily activities. Made from organic cotton, this robust and roomy tote measures 16"W x 14"H x 5.25"D and is ideal for errands, shopping, or promotional events. Other features include a 27" handle, exterior pockets and an interior pocket with zipper. Its natural color and strong construction make it a favorite among eco-conscious individuals and businesses. Durable, reusable, and environmentally friendly, this tote is a must-have for anyone looking to combine practicality with sustainability.\n\nSpecs:\nSKU: OR292\nMaterial: Organic Cotton\nSize: 16"W x 14"H x 5.25"D\nHandle Length: 27"\nExterior Pockets\' Size: 4"W x 8"H\nInterior Pocket Size (With Zipper): 7.25"W x 7.75"L\nImprint Area: 3"W x 9"H\nPackage Quantity: 6 pcs\nCase Quantity: 48 pcs',
  tags: [],
  msrpDollars: 11.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:45.305Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
